module.exports = __webpack_public_path__ + "static/media/icon-custo.d6d22fbb.svg";